
var sprite = require("C:/git/annenberg-petspace-petbook/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 12.41 20.58\" id=\"arrow-right\" ><title>Asset 2</title><g data-name=\"Layer 2\"><path d=\"M1.5 20.58A1.5 1.5 0 0 1 .44 18l7.73-7.73L.44 2.56A1.5 1.5 0 0 1 2.56.44l9.85 9.85-9.85 9.85a1.5 1.5 0 0 1-1.06.44z\" data-name=\"Layer 1\"/></g></symbol>";
module.exports = sprite.add(image, "arrow-right");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-right.svg
// module id = 297
// module chunks = 1